import api from "@/api";

class MessageQueue {

    constructor(cadRequestId,processingCallback,closedCallback) {
        this.cadRequestId = cadRequestId;
        this.closedCallback = closedCallback;
        this.queue = [];
        this.processing = false;
        this.timeout = null;
        this.processingCallback = processingCallback;
    }

    enqueue(message) {
        this.queue.push(message);
        this.process();
    }

    process() {
        // sanity check
        if (this.queue.length == 0) {
            this.processing = false;
            return;
        } else if (this.processing) {
            return;
        }

        this.processing = true;
        this.doprocess();

    }
    clear() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.queue = [];
    }
    doprocess() {
        api.incident.message.post(this.cadRequestId,this.queue[0]).then((data) => {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.queue.shift();
            if (this.processingCallback) {
                this.processingCallback(this.queue.length);
            }
            if (this.queue.length == 0) {
                this.processing = false;
            } else {
                this.doprocess();
            }
        },(error) => {
            const isNetworking = error.is_network_error;
            if (isNetworking) {
                console.log("Network Error Detected... Queue Size is " + this.queue.length);
                if (this.processingCallback) {
                    this.processingCallback(this.queue.length);
                }
                this.timeout = setTimeout(() => {
                    console.log('Reprocessing... ');
                    this.doprocess();
                }, 5000);
            } else if (error.code == 'CLOSED_INCIDENT') {

                this.clear();
                if (this.closedCallback) {
                    this.closedCallback();
                }
            } else {
                this.timeout = setTimeout(() => {
                    this.doprocess();
                },5000);
            }
        });
    }

    isProcessing() {
        return this.processing;
    }
}


export default MessageQueue